import { useNavigate } from 'react-router-dom'

// Optional: Creative Tim-specific components
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDTypography from 'components/MDTypography'
import { useAuth } from 'context/auth'

const NotFound = () => {
	const { user } = useAuth()
	const navigate = useNavigate()

	return (
		<MDBox
			height="100vh"
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			textAlign="center"
			bgcolor="background.default"
			px={2}
		>
			<MDTypography variant="h1" fontSize={120} color="primary" fontWeight="bold">
				404
			</MDTypography>

			<MDTypography variant="h4" color="text">
				<i>Page not found</i>
			</MDTypography>

			<MDTypography variant="body1" color="text" mt={2} mb={4} maxWidth="400px">
				Sorry, the page you're looking for doesn't exist or has been moved.
			</MDTypography>
			{user && (
				<MDButton variant="outlined" color="info" onClick={() => navigate('/')}>
					Go to Dashboard
				</MDButton>
			)}
		</MDBox>
	)
}

export default NotFound
